export default "__VITE_ASSET__936e2e7a__"